import { render } from "./QueueList.vue?vue&type=template&id=fd0b4738&scoped=true&ts=true"
import script from "./QueueList.vue?vue&type=script&lang=ts"
export * from "./QueueList.vue?vue&type=script&lang=ts"

import "./QueueList.vue?vue&type=style&index=0&id=fd0b4738&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd0b4738"]])

export default __exports__